import {
  COOKIE_NAME,
  COOKIE_DOMAIN,
  EMBED_LAYER_PARAM,
  EMBED_MODAL_PARAM,
  EMBED_CONTAINER_SELECTOR,
  BehaviorTypes
} from './constants';

const {Cookies} = window;

/**
 * Clase que se encargará de ejecutar acciones para que se desactiven
 */
class Behavior {
  constructor({type, url, queryString, delay}) {
    this.options = {type, url, queryString, delay};
  }

  init() {
    switch (this.options.type) {
      case BehaviorTypes.REDIRECT:
        this.redirect();
        break;
      case BehaviorTypes.EMBED:
        this.embed();
        break;
      default:
        throw Error('[AdblockDetector] Missing behavior configuration');
    }
  }

  /**
   * Redirect behavior
   */
  redirect() {
    // NOTE: if cookie exist redirect without delay
    if (Cookies.get(COOKIE_NAME)) {
      window.location = this.options.url;
    } else {
      // NOTE: if cookie NOT exist redirect with delay
      setTimeout(() => {
        Cookies.set(COOKIE_NAME, COOKIE_NAME, {path: COOKIE_DOMAIN});
        window.location = this.options.url;
      }, this.options.delay * 1000);
    }
  }

  /**
   * Embed behavior(layer and popup)
   */
  embed() {
    var ajaxCall;
    // If cookie exist show layer
    if (Cookies.get(COOKIE_NAME)) {
      ajaxCall = this.getTemplate(this.options.url + EMBED_LAYER_PARAM);
      ajaxCall.then((data) => {
        window.Voonto.$(EMBED_CONTAINER_SELECTOR).html(data);
      });
    } else {
      // If cookie NOT exist show popup
      ajaxCall = this.getTemplate(this.options.url + EMBED_MODAL_PARAM);
      ajaxCall.then((data) => {
        setTimeout(() => {
          var modal$ = window.Voonto.$(data);
          window.Voonto.$(EMBED_CONTAINER_SELECTOR).prepend(modal$);
          modal$.modal('show');
          Cookies.set(COOKIE_NAME, COOKIE_NAME, { expires: 7, path: COOKIE_DOMAIN});
        }, this.options.delay * 1000);
      });
    }
    ajaxCall.catch((jqXHR, textStatus, errorThrown) => {
      throw new Error(errorThrown);
    });
  }

  getTemplate(url) {
    return window.Voonto.$.ajax({url: url + this.options.queryString});
  }

}

export default Behavior;




// WEBPACK FOOTER //
// ./src/behavior.js